module.exports = __webpack_public_path__ + "static/media/abarth.3943732b.png";